module.exports = __webpack_public_path__ + "static/home-img-7f8c294c1993d697ab64459d81c89b3b.png";